export function setupForm() {
  window.Stripe.setPublishableKey($('meta[name="stripe-key"]').attr('content'));
  $('#new_subscription').submit(validate);

  $('#company_subdomain')
    .bind('change', cleanseSubdomain)
    .bind('ICMIB:subdomain', checkSubdomainOnly);
  $('#company_name').bind('change', checkName);
  $('#terms').bind('change', checkTerms);
  $('#coupon').bind('change', checkCoupon);
  $('.coupon_form')
    .bind('submit', checkCoupon)
    .find('.icon_ajax')
    .hide();
}

let valid = true;

function validate(e) {
  e.preventDefault();

  // Assume valid
  valid = true;

  // Disable submit
  $('#submit_subscription').attr('disabled', true);

  // Check company name
  checkName();
  // Check subdomain
  checkSubdomain();

  // Check name and address fields
  checkCardName();
  checkCardAddress();

  // Check terms
  checkTerms();
  // If stripe fields are present, check stripe
  processCard();

  return false;
}

function ajaxDone(submit) {
  // return if we just did a one-off subdomain request, not a form submit
  if (submit !== undefined && !submit) return false;
  if (waiting_for_stripe || waiting_for_sub) return false;
  if (!valid) {
    isInvalid();
    return false;
  }
  submitForm();
}

function isInvalid() {
  // Scroll window to the first error message
  var $msg = $('.error_message').first();
  if ($msg.length) window.scrollTo(0, $msg.parent().offset().top);
  // Re-enable submit
  $('#submit_subscription').removeAttr('disabled');
}

// switch letting us know if we're waiting on stripe
let waiting_for_stripe = false;

function processCard() {
  if (!$('#card_number').length) return false;
  if ($('#blg_info').is(':hidden')) return false;

  let card = {
    number: $('#card_number').val(),
    cvc: $('#card_code').val(),
    expMonth: $('#card_month').val(),
    expYear: $('#card_year').val(),
    addressZip: $('#card_address_zip').val(),
  };
  waiting_for_stripe = true;
  window.Stripe.createToken(card, handleStripeResponse);
}

function handleStripeResponse(status, response) {
  $('#stripe_error').text('');
  if (status == 200) {
    $('#subscription_stripe_card_token').val(response.id);
  } else {
    $('#stripe_error').text(response.error.message);
    valid = false;
  }
  waiting_for_stripe = false;
  ajaxDone();
}

// switch letting us know if we're waiting for subdomain
let waiting_for_sub = false;
function checkSubdomainOnly() {
  checkSubdomain(false);
}

function checkSubdomain(submit) {
  var $sub = $('#company_subdomain');
  var valid = true;

  if (!$sub.length) return true;

  if (submit === undefined) submit = true;

  $.ajax({
    url: $sub.data('unique-subdomain-url'),
    data: { subdomain: $sub.val() },
    beforeStart: function() {
      waiting_for_sub = true;
    },
    complete: function() {
      if (!valid) valid = false;
      waiting_for_sub = false;
      ajaxDone(submit);
    },
    success: function(data) {
      if (data.success) {
        removeErrorMessage('company_subdomain');
        valid = true;
      } else {
        buildErrorMessage('company_subdomain', data.message);
        valid = false;
        valid = false;
      }
    },
    error: function() {
      valid = false;
    },
  });

  return valid;
}

function checkName() {
  checkRequiredField('company_name');
}

function checkCardName() {
  if (!$('#card_name').is(':visible')) return true;
  checkRequiredField('card_name');
}

function checkCardAddress() {
  if (!$('#card_address_line1').is(':visible')) return true;
  checkRequiredField('card_address_line1');
}

function checkRequiredField(field) {
  if (!$('#' + field).length) return true;

  removeErrorMessage(field);
  var valid = $('#' + field).val().length;
  if (!valid) valid = false;
  if (!valid) buildErrorMessage(field, ICMIB.t('field_required'));
  return valid;
}

function checkTerms() {
  if (!$('#terms').length) return true;

  removeErrorMessage('terms');
  var valid = $('#terms')[0].checked;
  if (!valid) valid = false;
  if (!valid) buildErrorMessage('terms', ICMIB.t('field_required'));
  return valid;
}

function submitForm() {
  $('#new_subscription')[0].submit();
}

function buildErrorMessage(name, msg) {
  removeErrorMessage(name);

  var $field = $('#' + name);
  if (msg === undefined) msg = ICMIB.t('general_validation_error');

  var $error = $('<div></div>')
    .text(msg)
    .addClass('error_message');
  $field.parent().append($error);
}

function removeErrorMessage(name) {
  $('#' + name)
    .siblings('.error_message')
    .remove();
}

function cleanseSubdomain() {
  var $this = $(this),
    sub = cleanse($this.val());
  $this.val(sub);
  $this.trigger('ICMIB:subdomain');
}

// Borrowed from jquery slugger
// http://patbenatar.github.com/jquery-slugger/
function cleanse(str) {
  var cStr = str.replace(/^\s+|\s+$/g, '');
  var from, i, to, _ref;
  cStr = str.toLowerCase();
  cStr = cStr.replace(/\./g, '');
  from = 'åãàáäâẽèéëêìíïîõòóöôùúüûñç·/,:;';
  to = 'aaaaaaeeeeeiiiiooooouuuunc-----';
  for (
    i = 0, _ref = from.length - 1;
    0 <= _ref ? i <= _ref : i >= _ref;
    0 <= _ref ? i++ : i--
  ) {
    cStr = cStr.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  cStr = cStr
    .replace(/[^a-z0-9 -_]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
  return cStr;
}

function checkCoupon(e) {
  var $this = $('.coupon_form'),
    $msg = $this.find('.msg'),
    $ajax = $this.find('.icon_ajax').hide(),
    url = $this.attr('action'),
    method = $this.attr('method');

  if (!url) url = $('#coupon').data('url');
  if (!method) method = 'GET';

  e.preventDefault();
  $.ajax({
    url: url,
    data: $('#coupon').serialize(),
    type: method,
    beforeSend: function() {
      $msg.html('');
      $ajax.show();
    },
    complete: function() {
      $ajax.hide();
    },
    success: function(data) {
      if (data.success) {
        if (data.message) {
          $this.hide();
          $this.after(data.message);
        }
      } else {
        var icon = "<span class='icon icon_warning'></span> ";
        $msg.html(icon + data.message);
      }
    },
  });
  return false;
}

export function watchCouponField() {}

export function choosePlan() {
  var $plan_id = $('#subscription_plan_id');

  $('.change_plans_table').delegate('th a', 'click', function(e) {
    var $this = $(this),
      $th = $this.closest('th');

    // Dont do anything if this one is already selected
    if ($th.hasClass('highlighted')) return false;

    // Don't do anything if they clicked the enterprise plan
    if ($this.hasClass('enterprise')) {
      return window.confirm($this.data('confirm')) ? true : false;
    }

    e.preventDefault();

    // Remove highlighted class from currently selected
    $th
      .closest('tr')
      .find('.highlighted')
      .removeClass('highlighted');

    // Apply highlighted class to this one
    $th.addClass('highlighted');

    // Set the hidden field
    $plan_id.val($this.data('id'));

    return false;
  });
}
